import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/JobsFairs1234.css";

import jobCardImage1 from "../../assets/jobfairs4.png";
import jobCardImage2 from "../../assets/JobsFairs3.png";
import jobfairs from "../../assets/jobfairs.mp4";

import ServicesJobsandjoobfairRegister from "../ServicesJobsandJoobfairRegister";

const JobsFairs = () => {
  const jobs = [
    {
      title: "National Job Fair",
      orginazition: "Infosys",
      date: "Sep 20",
      time: "10AM - 5PM",
      location: "Ameerpet",
      image: jobCardImage1,
    },
    {
      title: "National Job Fair",
      orginazition: "Infosys",
      date: "Sep 20",
      time: "10AM - 5PM",
      location: "Ameerpet",
      image: jobCardImage2,
    },
  ];

  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => setShowPopup(true);

  const closePopup = () => setShowPopup(false);

  return (
    <>
      <section className="jobsfair1234-wrapper" id="jobs">

        <div className="jobsfair1234-section">

          {/* =====================================================
              TOP HERO / INTRO SECTION
          ===================================================== */}

          <div className="jobsfair1234-hero">

            {/* LEFT CONTENT */}
            <div className="jobsfair1234-hero-content">

              {/* <div className="jobsfair1234-small-badge">
                <span className="jobsfair1234-badge-icon">💼</span>
                Career Opportunities
              </div> */}

              <h1 className="jobsfair1234-title">
                JOBS <span>&</span>{" "}
                <strong>JOB FAIRS</strong>
              </h1>

              <div className="jobsfair1234-title-line"></div>

              <p className="jobsfair1234-description">
                Explore the latest job opportunities and career fairs.
                Connect with top employers, discover new roles, and advance
                your career. Attend events to network with industry leaders
                and gain insights.
              </p>

              <p className="jobsfair1234-description jobsfair1234-description-second">
                Stay updated on trends and unlock new opportunities for
                growth. Take charge of your career and open doors to exciting
                professional opportunities.
              </p>

            </div>


            {/* RIGHT VIDEO */}
            <div className="jobsfair1234-hero-video">

              <div className="jobsfair1234-video-container">

                <video
                  src={jobfairs}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="jobsfair1234-video"
                />

                {/* PLAY OVERLAY */}
                {/* <div className="jobsfair1234-video-play">
                  <span>▶</span>
                </div> */}

              </div>

            </div>

          </div>


          {/* =====================================================
              JOB CARDS
          ===================================================== */}

          <div className="jobsfair1234-list">

            <div className="jobsfair1234-grid">

              {jobs.map((job, index) => (

                <div className="jobsfair1234-event-card" key={index}>

                  {/* =================================================
                      LEFT CONTENT - 50%
                  ================================================= */}

                  <div className="jobsfair1234-event-content">

                    <h3 className="jobsfair1234-event-title">
                      {job.title}
                    </h3>

                    <div className="jobsfair1234-job-title-line"></div>


                    {/* ORGANIZATION */}
                    <div className="jobsfair1234-job-detail">

                      <span className="jobsfair1234-job-detail-icon">
                        🏢
                      </span>

                      <span>
                        Organization Name:
                        <strong>{job.orginazition}</strong>
                      </span>

                    </div>


                    {/* DATE */}
                    <div className="jobsfair1234-job-detail">

                      <span className="jobsfair1234-job-detail-icon">
                        📅
                      </span>

                      <span>
                        Date:
                        <strong>{job.date}</strong>
                      </span>

                    </div>


                    {/* TIME */}
                    <div className="jobsfair1234-job-detail">

                      <span className="jobsfair1234-job-detail-icon">
                        🕐
                      </span>

                      <span>
                        Time:
                        <strong>{job.time}</strong>
                      </span>

                    </div>


                    {/* LOCATION */}
                    <div className="jobsfair1234-job-detail">

                      <span className="jobsfair1234-job-detail-icon">
                        📍
                      </span>

                      <span>
                        Location:
                        <strong>{job.location}</strong>
                      </span>

                    </div>


                    {/* REGISTER BUTTON */}
                    <button
                      className="jobsfair1234-register-btn"
                      onClick={openPopup}
                    >
                      REGISTER NOW
                      <span className="jobsfair1234-register-arrow">
                        →
                      </span>
                    </button>

                  </div>


                  {/* =================================================
                      RIGHT IMAGE - 50%
                  ================================================= */}

                  <div className="jobsfair1234-event-image-wrapper">

                    <img
                      src={job.image}
                      alt="job fair"
                      className="jobsfair1234-event-image"
                    />

                  </div>

                </div>

              ))}

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          REGISTRATION POPUP
      ===================================================== */}

      <ServicesJobsandjoobfairRegister
        show={showPopup}
        onClose={closePopup}
      />

    </>
  );
};

export default JobsFairs;